(() => {
  const CHECKOUT = 'button[name="checkout"], #CartDrawer-Checkout, #checkout, a[href^="/checkout"]';
  const $ = (s, r = document) => r.querySelector(s);

  const gate = () => $('[data-ace-terms]');
  const isAccepted = () => gate()?.dataset.accepted === 'true';

  async function saveAttributes(accepted) {
    const g = gate();
    const attributes = accepted
      ? {
          ace_terms_accepted: 'true',
          ace_terms_version: g.dataset.version,
          ace_terms_accepted_at: new Date().toISOString(),
        }
      : { ace_terms_accepted: '', ace_terms_version: '', ace_terms_accepted_at: '' }; // empty string removes it
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
    });
  }

  // Re-fetch the drawer section and swap in the fresh gate
  let refreshing = false;
  async function refreshGate() {
    if (refreshing) return;
    refreshing = true;
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`);
      const json = await res.json();
      const doc = new DOMParser().parseFromString(json['cart-drawer'], 'text/html');
      const newRoot = doc.querySelector('[data-ace-root]');
      const oldRoot = document.querySelector('[data-ace-root]');
      if (newRoot && oldRoot) {
        document.querySelectorAll('body > [data-ace-modal]').forEach((m) => m.remove());
        oldRoot.innerHTML = newRoot.innerHTML;
        sync();
      }
    } catch (err) {
      console.error('ACE gate refresh failed', err);
    } finally {
      refreshing = false;
    }
  }

  // Refresh after add / change / update (skip our own attribute save)
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await origFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      const isCartWrite = /\/cart\/(add|change|update|clear)/.test(url);
      const isOurs = args[1]?.body?.includes?.('ace_terms');
      if (isCartWrite && !isOurs) setTimeout(refreshGate, 300);
    } catch (_) {}
    return res;
  };

  function sync() {
    const g = gate();
    const locked = !!g && !isAccepted();
    document.querySelectorAll(CHECKOUT).forEach((btn) => {
      btn.classList.toggle('ace-gated', locked);
      if (locked) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });

    // Move the fresh modal to <body>; drop any stale copy left from a previous render
    const fresh = document.querySelector('[data-ace-root] [data-ace-modal]');
    if (fresh) {
      document.querySelectorAll('body > [data-ace-modal]').forEach((m) => m.remove());
      document.body.appendChild(fresh);
    }

    const cb = $('[data-ace-checkbox]');
    if (cb && g) cb.checked = isAccepted();
  }

  const openModal = () => { const m = $('[data-ace-modal]'); if (m) m.hidden = false; };
  const closeModal = () => { const m = $('[data-ace-modal]'); if (m) m.hidden = true; };

  // Checkbox: unchecked -> open popup; checked -> allow uncheck and re-lock
  document.addEventListener('click', async (e) => {
    const cb = e.target.closest('[data-ace-checkbox]');
    if (cb) {
      if (!isAccepted()) {
        e.preventDefault();
        openModal();
      } else {
        gate().dataset.accepted = 'false';
        $('[data-ace-error]').hidden = true;
        sync();
        await saveAttributes(false);
      }
      return;
    }

    if (e.target.closest('[data-ace-close]')) return closeModal();

    if (e.target.closest('[data-ace-accept]')) {
      const g = gate();
      if (!g) return closeModal();
      g.dataset.accepted = 'true';
      $('[data-ace-error]').hidden = true;
      closeModal();
      sync();
      await saveAttributes(true);
      return;
    }

    // Block checkout while not accepted
    const btn = e.target.closest(CHECKOUT);
    if (btn && gate() && !isAccepted()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const err = $('[data-ace-error]');
      if (err) err.hidden = false;
    }
  }, true);

  // Also block Enter-key form submits to checkout
  document.addEventListener('submit', (e) => {
    if (gate() && !isAccepted() && e.submitter?.matches?.(CHECKOUT)) {
      e.preventDefault();
      const err = $('[data-ace-error]');
      if (err) err.hidden = false;
    }
  }, true);

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });

  // Cart drawer re-renders via the Section Rendering API, so re-sync on DOM changes
  let raf;
  new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); })
    .observe(document.body, { childList: true, subtree: true });

  sync();
})();